document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.editorial-gallery');
  const slides = Array.from(document.querySelectorAll('.gallery-slide'));
  const nextBtn = document.querySelector('.gallery-next');
  const prevBtn = document.querySelector('.gallery-prev');

  if (!track || slides.length === 0) return;

  let index = 0;

  function visible() {
    return window.innerWidth <= 749 ? 1 : 3;
  }

  function step() {
    const slideWidth = slides[0].getBoundingClientRect().width;
    return slideWidth;
  }

  function maxIndex() {
    return Math.max(0, slides.length - visible());
  }

  function move(animate = true) {
    track.style.transition = animate ? 'transform 0.5s ease' : 'none';
    track.style.transform = `translateX(-${index * step()}px)`;
  }

  function next() {
    const max = maxIndex();
    index = index >= max ? 0 : index + 1;
    move(true);
  }

  function prev() {
    const max = maxIndex();
    index = index <= 0 ? max : index - 1;
    move(true);
  }

  nextBtn?.addEventListener('click', next);
  prevBtn?.addEventListener('click', prev);

  window.addEventListener('resize', () => move(false));

  // CRITICAL FIX: wait for images
  window.addEventListener('load', () => move(false));
});